
































































import {Vue, Component, Ref, Prop} from 'vue-property-decorator';
import Grid from '@/pro/components/common/grid/Main.vue';
import { Getter } from 'vuex-class';
import {
  Mall,
  NCPResponse,
  GetProductsExcelFailResultsRequest,
  GetProductsExcelRegisterFormRequest,
  PostProductsSearchByKeyRequest,
  PostProductsExcel,
} from 'ncp-api-supporter';
import { PostProductsSearchByKey } from 'ncp-api-supporter/dist/types/modules/product/product';
import UploadForm from '@/pro/components/product/common/UploadForm.vue';
import {containerOptions, gridProps} from '@/pro/views/contents/product/basic/ProductBulkAdd';
import {setNoDataMessage} from '@/pro/helpers/grid';
import {getDownToday, getStrYMDHMSS, getToday} from '@/pro/utils/dateFormat';
import {ExcelUploadType} from '@/pro/types/ProductThumbnailRegistration';
import {saveBinaryDataToFile} from '@/pro/utils/fileSaver';
import {GridEventProps} from '@/pro/types';
import {Row} from '@/pro/types/tui-grid';
import {openSupplyPriceDetailsPopup} from '@/pro/components/product/common/girdColumns/ProductSupplyPrice';
import {throwWindowPopup} from '@/pro/helpers/popup';
import PageLayout from '@/pro/views/PageLayout.vue';
import NoticeBox from '@/pro/components/common/NoticeBox.vue';

@Component({
  components: {NoticeBox, PageLayout, Grid, UploadForm },
})
export default class ProductBulkAdd extends Vue {
  @Prop({ required: true })
  private readonly title: string;
  
  @Getter('mall/malls') private malls!: Mall[];
  private gridProps = gridProps;
  private gridContainerOptions = containerOptions();
  private uploadDate = '';
  private mallProductNos: number[] = [];
  private successCount = 0;
  private productsTotalCount = 0;
  private gridTotalCount = 0;
  private productsData: PostProductsSearchByKey[] = [];
  private uploadedImages: string[] = [];
  private mallNo = '';


  @Ref() private readonly grid: Grid;

  created() {
    setNoDataMessage(this.$t('PRO_PRODUCT_BULK_IMAGE_NO_DATA').toString());
  }

  private async searchProducts() {
    const request: PostProductsSearchByKeyRequest = {
      data: {
        mallNos: [this.mallNo],
        mallProductNos: this.mallProductNos,
      },
    };
    try {
      const { data }: NCPResponse<PostProductsSearchByKey[]> = await this.$api.postProductsSearchByKey(request);
      this.productsData = data;
      this.gridTotalCount = data.length;
      this.uploadDate = getStrYMDHMSS(new Date());
    } catch (e) {
      console.error(e);
    }
  }

  private async postExcelFile({ excelFile, resultPopup, mallNo }: ExcelUploadType) {
    const formData = new FormData();
    formData.append('excelFile', excelFile);
    formData.append('mallNo', mallNo);
    formData.append('uploadedImages', this.uploadedImages.toString());
    try {
      const { data }: NCPResponse<PostProductsExcel> = await this.$api.postProductsExcelBulk({ data: formData });
      const { failCount, seq, successCount, successMallProductNos } = data;
      const totalCount = successCount + failCount;
      resultPopup({ successCount, failCount, totalCount });
      this.productsTotalCount = totalCount;
      this.successCount = successCount;
      if (failCount > 0) {
        const mallName = this.getMallName(mallNo);
        await this.downloadFailedExcel(seq, mallName);
      }

      if (successMallProductNos.length) {
        this.mallProductNos = successMallProductNos;
        await this.searchProducts();
      }
    } catch (e) {
      console.error(e);
    }
  }

  private getMallName(mallNo: string) {
    return this.malls.find(mall => mall.mallNo === Number(mallNo)).mallName;
  }

  private async downloadFailedExcel(failureNumber: number, mallName: string) {
    const fileName = `${mallName}_${this.$t('PRO_PRODUCT_BULK_PRODUCT_FAILED_EXCEL_FILE_NAME')}_${getDownToday()}.xlsx`;
    const params: GetProductsExcelFailResultsRequest['params'] = { seq: failureNumber, mallNo: Number(this.mallNo) };
    try {
      const { data } = await this.$api.getProductsExcelFailResults({ params, responseType: 'arraybuffer' });
      saveBinaryDataToFile(data, fileName);
    } catch (e) {
      console.error(e);
    }
  }

  private onItemClicked({ rowKey, columnName }: GridEventProps) {
    const rowInfo: Row = this.grid.getRowAt(rowKey);

    switch (columnName) {
      case 'supplyPrice':
        openSupplyPriceDetailsPopup(rowInfo);
        break;
      default:
        break;
    }
  }

  private openImageUploadPopup() {
    throwWindowPopup(
      'ImageUpload',
      { mallNo: this.mallNo, uploadedFiles: this.uploadedImages },
      'md',
      ({ data }) => (this.uploadedImages = data),
      null,
      null,
      null,
      500,
    );
  }

  private async downloadSampleExcel() {
    try {
      const request: GetProductsExcelRegisterFormRequest = {
        params: {
          mallNo: Number(this.mallNo),
        },
      };
      const mallName = this.getMallName(this.mallNo);
      const fileName = `${mallName}_${this.$t('PRO_PRODUCT_BULK_PRODUCT_EXCEL_SAMPLE_FILE_NAME')}_${getToday(
        'YYYYMMDD',
      )}.xlsx`;
      const { data }: NCPResponse<ArrayBuffer> = await this.$api.getProductsExcelRegisterForm(request);
      saveBinaryDataToFile(data, fileName);
    } catch (e) {
      console.error(e);
    }
  }
}
